<template>
  <ActListBox
    listType="row"
    :api="postHotfts"
    :params="params"
    type="10"
    from="babe"
    :title="$t('new.text57') + ' NFT'" />
</template>
<script>
import { postHotfts } from '@/api/user'
import ActListBox from '@/components/ActListBox.vue'

export default {
  name: 'BabeSpaceList',
  components: { ActListBox },
  watch: {
    '$i18n.locale'() {
      this.init()
    }
  },
  data() {
    return {
      postHotfts,
      params: { category_id: 3 }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== 'BabeNftDetail') {
      this.$store.commit('SET_KEEP_ALIVE', [])
    }
    next()
  },
  created() {},
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/views/babe/spacelist.vue